import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { CarCard } from "@tenant/cars";
import { Button, ButtonTypeEnum } from "@tenant/ui";
import clsx from "clsx";
import { CarAvailabilityLink } from "../PackageCarAvailabilityLink";
import { PackageCarPriceDisplay } from "../PackageCarPriceDisplay";
import defaultStyles from "./CarAvailabilityCard.module.scss";
import { useCarAvailabilityCard } from "./hook";
import type { VehicleAvailabilityWithSupplier } from "~core-cars/store";
import { useCarsStyles } from "~core-cars/themes";
import { CarsRawEventName, useEmitCoreCarsRawEvent } from "~core-cars/tracking";
import { CoreCarsComponent } from "~core-cars/types";

export type CarAvailabilityCardType = {
  car: VehicleAvailabilityWithSupplier;
  index?: number;
} & PlatformComponentProps;

const COMPONENT_KEY = CoreCarsComponent.CarAvailabilityCard;

export const CarAvailabilityCard = (props: CarAvailabilityCardType) => {
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { context, handlers } = useCarAvailabilityCard(props);
  const { t } = useI18nContext();

  const { className, children } = props;

  const emitEvent = useEmitCoreCarsRawEvent(
    CarsRawEventName.ClickedCarOnAvailability
  );

  return (
    <div className={clsx(block, className)}>
      <CarAvailabilityLink car={context.car}>
        <CarCard className={cn("card")} car={context.car}>
          <div className={cn("price-container")}>
            <div className={cn("price")}>
              <PackageCarPriceDisplay
                prices={context.prices}
                formatOptions={{ signDisplay: "always" }}
              />
            </div>
          </div>
          <Button
            className={cn("select-button")}
            buttonType={ButtonTypeEnum.Primary}
            onClick={(e) => {
              e.stopPropagation();
              emitEvent();
              handlers.goToShop();
            }}
          >
            {t("core-cars.carCard.select")}
          </Button>
          {children}
        </CarCard>
      </CarAvailabilityLink>
    </div>
  );
};
